"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _lodash = require("lodash");
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _dom = _interopRequireDefault(require("src/utils/dom"));
var _eid = require("src/utils/eid");
var _constants = require("libs/utils/constants");
var _url = require("libs/utils/url");
var _workspaces = require("libs/utils/workspaces");
var _routes = require("libs/utils/routes");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; } // angular's int main()
// We import moment here because it can't be imported dynamically
// since it's an external dependency found in the `external-modules.js`.
var CONTROLLERS = ['agenda', 'crud', 'data', 'events', 'main', 'misc', 'orgs', 'users', 'features', 'navs', 'widgets', 'brandedApps', 'tools', 'theme-editor', 'participants'];
var DIRECTIVES = ['forms', 'tables', 'externals', 'naveditors', 'quill', 'validation', 'brandedApps', 'tools', 'theme-editor'];
var NG_DEPENDENCIES = ['backstage.templates', 'backstage.directives', 'backstage.services', 'backstage.filters', 'backstage.components', 'ngRoute', 'ngSanitize', 'ngCookies', 'smartTable.table', 'ngProgressLite', 'ngUpload', 'ngMdHtmlForm', 'ngRepeatReorder', 'ui.select2', 'textAngular'];
angular.module('backstage', (0, _lodash.chain)() // include directives, controllers
.union(DIRECTIVES.map(function (_directive) {
  return "backstage.directives.".concat(_directive);
})).union(CONTROLLERS.map(function (_ctrl) {
  return "backstage.controllers.".concat(_ctrl);
})).union(NG_DEPENDENCIES).value())

// ####
.config( /* @ngInject */["$routeProvider", "$locationProvider", "$compileProvider", function ($routeProvider, $locationProvider, $compileProvider) {
  // use HTML5 mode when routing
  $locationProvider.html5Mode(true).hashPrefix('!');

  // allow fp-asset-like URLs
  $compileProvider.imgSrcSanitizationWhitelist(/^\s*((https?|ftp|file|blob|fp-asset):|data:image\/)/);

  // SPECIAL ROUTES

  $routeProvider.when('/event/:eventId/node-offline', {
    templateUrl: '/static/partials/node-offline.html',
    path: ['event-instance-content', 'node-offline-warning']
  });
}])

// https://git.io/vo1Qv
.value('EventEmitter', function (payload) {
  return {
    $event: payload
  };
})

// ####
.run( /* @ngInject */["ACCREDITED_LINK_TOKEN_PARAM", "BLUEPRINT_FULLSCREEN_PARAM", "$rootScope", "$window", "$location", "$route", "$timeout", "$q", "$http", "ngProgressLite", "routerService", "eventService", "urlService", "userService", "blueprintService", "metricsService", "signalService", "metadataService", "i18nService", "crashReporter", function (ACCREDITED_LINK_TOKEN_PARAM, BLUEPRINT_FULLSCREEN_PARAM, $rootScope, $window, $location, $route, $timeout, $q, $http, ngProgressLite, routerService, eventService, urlService, userService, blueprintService, metricsService, signalService, metadataService, i18nService, crashReporter) {
  if (window.BSTG.services.router.hasSavedUrl()) {
    window.BSTG.services.router.redirectToSavedUrl();
    return;
  }

  // we use this polyfill to make async/await work nice with angular's $digest:
  window.Promise = $q;

  // This is needed to make sure old packages will find moment when needed.
  window.moment = _momentTimezone.default;
  var eid = (0, _eid.getEid)();
  if (eid) {
    crashReporter.setScope({
      eid: eid
    });
  }

  /**
   * Load script with required order, with a fail safe mechanism.
   * Promise returned should in fact never fail
   * @param {...String} scripts
   * @return {Promise}
   */
  BSTG.require = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var _len,
      scripts,
      _key,
      eid,
      parser,
      _iterator,
      _step,
      script,
      _args = arguments;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          for (_len = _args.length, scripts = new Array(_len), _key = 0; _key < _len; _key++) {
            scripts[_key] = _args[_key];
          }
          scripts = (0, _lodash.flatten)(scripts).filter(function (script) {
            return !_constants.SOURCE_URL_BLACKLIST.includes(script);
          });
          if (scripts.length) {
            _context.next = 4;
            break;
          }
          return _context.abrupt("return", $q.resolve());
        case 4:
          eid = (0, _eid.getEid)();
          if (eid) {
            parser = document.createElement('a');
            scripts = scripts.map(function (href) {
              parser.href = href;
              // NOTE: this was setting parser.search before but IE dun' allow that
              //       the resulting error is "The URL is invalid." - how ambiguous!
              var appendage = parser.search && parser.search.length ? "&eid=".concat(eid) : "?eid=".concat(eid);
              return parser.href + appendage;
            });
          }
          _iterator = _createForOfIteratorHelper(scripts);
          _context.prev = 7;
          _iterator.s();
        case 9:
          if ((_step = _iterator.n()).done) {
            _context.next = 21;
            break;
          }
          script = _step.value;
          _context.prev = 11;
          _context.next = 14;
          return _dom.default.loadScript(script);
        case 14:
          _context.next = 19;
          break;
        case 16:
          _context.prev = 16;
          _context.t0 = _context["catch"](11);
          console.error("[BSTG.require] Could not load script ".concat(script), _context.t0.message);
        case 19:
          _context.next = 9;
          break;
        case 21:
          _context.next = 26;
          break;
        case 23:
          _context.prev = 23;
          _context.t1 = _context["catch"](7);
          _iterator.e(_context.t1);
        case 26:
          _context.prev = 26;
          _iterator.f();
          return _context.finish(26);
        case 29:
          return _context.abrupt("return", Promise.resolve());
        case 30:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[7, 23, 26, 29], [11, 16]]);
  }));

  /* Misc configuration */

  $rootScope.APP_INSTALL_SHORTLINK_PREFIX = 'https://install.events';

  // save them for later before $route kicks in and erase them
  $rootScope.savedSearchParams = $location.search();

  /* Standard top-level document field metadata */

  $rootScope.defaultDocTemplates = {
    mail: {
      type: 'mail'
    },
    localnode: {
      instanceurl: 'http://10.79.1.1',
      deviceip: '10.79.0.0',
      deviceipcidr: '16',
      role: 'standard'
    },
    bundle: {
      bundle_type: 'feature',
      permission: 'owner_only',
      assets: []
    }
  };
  $rootScope.defaultMetadataFields = {
    org: [{
      label: 'Organization',
      field: 'name',
      validations: {
        required: true,
        pattern: '(?!.*\/).*'
      }
    }, {
      label: 'Account ID',
      field: 'sf_account_id',
      tooltip: 'The Salesforce Account ID',
      validations: {
        required: true
      }
    }],
    orgSupportControls: [{
      field: 'enable_rtmps_slides',
      kind: 'boolean',
      label: 'Enable Slides in RTMPs'
    }, {
      field: 'show_live_captions',
      kind: 'boolean',
      label: 'Show Live Captions'
    }, {
      field: 'org_industry',
      label: 'Organization industry',
      kind: 'choice',
      default: 'other',
      kind_options: {
        values: {
          life_science: 'Life science',
          other: 'Other industries'
        }
      }
    }],
    orgSuperadminControls: [{
      field: 'bs_is_spotme',
      kind: 'boolean',
      label: 'Is SpotMe Org',
      tooltip: "\nVisible to superadmins only.\nSpotMe orgs are excluded from license checks and some email notifications\n"
    }, {
      field: 'bs_is_blocked',
      kind: 'boolean',
      label: 'Is Blocked',
      tooltip: 'Visible to superadmins only'
    }, {
      field: 'entitlements_enabled',
      kind: 'boolean',
      label: 'Entitlements Enabled',
      tooltip: 'Visible to superadmins only'
    }, {
      field: 'entitlements_v2',
      kind: 'boolean',
      label: 'Auto Entitlements',
      tooltip: 'Visible to superadmins only'
    }, {
      field: 'password_rotation_policy',
      kind: 'nested-object',
      kind_options: {
        fields: {
          enabled: {
            kind: 'boolean',
            label: 'Enabled'
          },
          duration: {
            kind: 'number',
            label: 'Duration (seconds)'
          }
        }
      },
      label: 'Password Rotation Policy',
      tooltip: 'Visible to superadmins only'
    }, {
      field: 'enable_anonymization',
      kind: 'boolean',
      label: 'Enable Behavioral Data Anonymization'
    }, {
      field: 'allow_non_unique_email',
      kind: 'boolean',
      label: 'User creation with shared email addresses',
      tooltip: 'Remember that when you turn this setting on, you are removing the requirement for the attendees’ email address to be unique.'
    }, {
      field: 'show_studio_express',
      kind: 'boolean',
      label: 'Show Spotme Express'
    }, {
      field: 'content_hubs_enabled',
      kind: 'boolean',
      label: 'Content hubs enabled'
    }, {
      field: 'studio_use_chime',
      kind: 'boolean',
      label: 'Always use AWS Chime in Studio'
    }, {
      field: 'hive',
      kind: 'nested-object',
      kind_options: {
        fields: {
          enabled: {
            kind: 'boolean',
            label: 'Enabled'
          },
          partnerId: {
            kind: 'text',
            label: 'Partner Id'
          },
          partnerToken: {
            kind: 'text',
            label: 'Partner Token'
          },
          customerId: {
            kind: 'text',
            label: 'Customer ID'
          }
        }
      },
      label: 'Hive'
    }],
    session_tag: [{
      label: 'Tag label',
      field: 'tag',
      default: 'General'
    }, {
      label: 'Tag color',
      field: 'tag_color',
      kind: 'colour'
    }],
    'nav-bit-ds-source': [{
      label: 'Section title',
      field: 'title',
      kind: 'choice',
      kind_options: {
        list_style: 'select'
      }
    }, {
      label: 'Icon Image',
      field: 'img',
      kind: 'external',
      kind_options: {
        type: 'icon',
        single_doc: true,
        id_field: '_id'
      }
    }],
    addUserTeamRoleForm: [{
      label: 'User\'s email address',
      field: 'email',
      tooltip: 'This is used to locate their user account in Backstage',
      attributes: {
        list: 'orgMemberEmails'
      },
      validations: {
        required: true
      }
    }, {
      label: 'Event ID',
      field: 'eventId',
      validations: {
        required: true
      }
    }, {
      label: 'Access role',
      field: 'role',
      kind: 'choice',
      kind_options: {
        values: {
          revoked: 'Revoke (remove from team)',
          manager: 'Manager',
          editor: 'Editor',
          viewer: 'Viewer'
        }
      },
      validations: {
        required: true
      }
    }]
  };

  /* Event listeners */

  // we must keep track of the previously accessed event ID here
  // as there's no way to get a hold of it in the support form controller or a resolver
  var context = null;
  var previouslyAccessedEventId = null;
  var previouslyAccessedLocationUri = null;
  function userRedirectedToInfra(url) {
    if ((0, _lodash.isString)(url)) {
      var currentUrl = (0, _url.isInfraUrl)(url);
      if (!(0, _url.isInfra)() && currentUrl) {
        window.BSTG.services.router.redirectToHome(currentUrl.pathname, currentUrl.search);
        return true;
      }
    }
    return false;
  }

  // we do all of the routey blueprinty things here
  $rootScope.$on('$locationChangeStart', function (event, next, current) {
    if (userRedirectedToInfra(current)) {
      return;
    }
    if (!ensureNavigationWarningShown()) {
      event.preventDefault();
      $rootScope.routeChangeInProgress = false;
      return;
    }
    if ($rootScope.userAllowedPaths && !$rootScope.userAllowedPaths.some(function (path) {
      return next.endsWith(path);
    })) {
      console.warn("[App] Location not allowed, preventing navigation to ".concat(next));
      return event.preventDefault();
    }
    if ((0, _lodash.isString)(current)) {
      previouslyAccessedLocationUri = current;
    }

    // navigating to another context? reload the page
    var currentContext = (0, _eid.getEid)() || 'global';
    if (!context) {
      context = currentContext;
    } else if (currentContext !== context) {
      window.location.href = current;
    }
  });
  $rootScope.$on('$routeChangeStart', function (event, next, current) {
    if (userRedirectedToInfra(current)) {
      return;
    }
    if ($rootScope.isAccountSuspended && (0, _lodash.get)(next, '$$route.originalPath') !== _constants.SUSPENDED_ROUTE) {
      $rootScope.navigateHard(_constants.SUSPENDED_ROUTE);
    }
    if ($rootScope.userAllowedPaths) {
      var currentPath = (0, _routes.buildPathFromRoute)(next);
      if (!$rootScope.userAllowedPaths.some(function (path) {
        return currentPath === path;
      })) {
        event.preventDefault();
        console.warn("[App] Route not allowed, preventing navigation to ".concat(currentPath));
        if (!current && $rootScope.userAllowedPaths.length) {
          console.warn("[App] Navigating to allowed path ".concat($rootScope.userAllowedPaths[0]));
          $rootScope.navigate($rootScope.userAllowedPaths[0]);
        }
        return;
      }
    }
    if ($location.path().match(/^\/content-hub\/.+$/)) {
      window.location.href = $location.path();
    }
    $rootScope.routeChangeInProgress = true;
    $timeout(function () {
      if (!ngProgressLite.isRendered() && $rootScope.routeChangeInProgress) {
        ngProgressLite.start();
        return ngProgressLite.set(0.2);
      }
    }, 1000);

    // keep the previously accessed eid across route changes (used in the support form)
    if (current && current.params && current.params.eventId) {
      previouslyAccessedEventId = current.params.eventId;
    }

    // keep the fullscreen token state across route changes
    var fullscreenParams = (0, _lodash.pick)((current ? current.params : undefined) || {}, BLUEPRINT_FULLSCREEN_PARAM);
    if (!(0, _lodash.keys)(fullscreenParams).length) {
      return;
    }
    var currentSearch = $location.search();
    return $location.search(angular.extend({}, currentSearch, fullscreenParams));
  });
  $rootScope.$on('$routeChangeSuccess', function (event, current /* , previous */) {
    $rootScope.routeChangeInProgress = false;
    $timeout(function () {
      if (ngProgressLite.isRendered() && !$rootScope.routeChangeInProgress) {
        return ngProgressLite.done();
      }
    }, 200);

    // prevents a repeat show of the navigation warning message
    $rootScope.navigationWarningMessage = null;

    // tracking
    var eventId = ((current || {}).params || {}).eventId;
    var bp = (($route.current || {}).$$route || {}).blueprintMetadata;
    window.BSTG.services.track.pageChanged();
    return metricsService.track('bstg_nav', {
      module: bp ? bp.moduleKey : undefined,
      controller: bp ? bp.controllerKey : undefined,
      path: $location.$$path.replace(eventId + '/', '')
    });
  });
  $rootScope.$on('$routeChangeError', function /* event, current, previous, rejection */
  () {
    // ⚑
    // TODO: Display an error of some description
    $rootScope.routeChangeInProgress = false;
  });

  // hide the flash message after six seconds
  var flashMessageResetPromise = null;
  $rootScope.$watch('flashMessage', function (newValue) {
    if (!newValue || !newValue.message) {
      return;
    }
    if (flashMessageResetPromise) {
      $timeout.cancel(flashMessageResetPromise);
    }
    flashMessageResetPromise = $timeout(function () {
      flashMessageResetPromise = null;
      return $rootScope.unsetFlashMessage();
    }, 8000);
  });

  /* rootScope methods */

  var ensureNavigationWarningShown = function ensureNavigationWarningShown() {
    if (!(0, _lodash.isString)($rootScope.navigationWarningMessage)) {
      return true;
    }
    var ret = confirm($rootScope.navigationWarningMessage);
    if (ret) {
      $rootScope.navigationWarningMessage = null;
    }
    return ret;
  };

  // substituteParamsInRoutePath: used in <a href="">'s, so base path is included
  $rootScope.substituteParamsInRoutePath = urlService.substituteParamsInRoutePathWithBasePath;

  // navigate to a route in the current SPA instance
  $rootScope.navigate = function (path) {
    var getCurrentRoutePaths = function getCurrentRoutePaths() {
      var currentRoute = $route.current ? $route.current.$$route : undefined;
      if (!currentRoute) {
        return [];
      }
      var route = ((currentRoute.blueprintMetadata || {}).controller || {}).route || currentRoute.originalPath;
      return (0, _lodash.flatten)([route]);
    };

    // don't navigate if requested path is route of current controller
    if (getCurrentRoutePaths().includes(path)) {
      return;
    }
    if (!(0, _lodash.isString)(path)) {
      return;
    }
    for (var _len2 = arguments.length, substitutions = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      substitutions[_key2 - 1] = arguments[_key2];
    }
    return $location.path(urlService.substituteParamsInRoutePath(path, substitutions));
  };

  // navigate to a route outside the SPA
  $rootScope.navigateHard = function (path) {
    if (!ensureNavigationWarningShown()) {
      return;
    }
    // figure out our base URL in a dirty way
    var base = $('html > head > base').attr('href') || '/';
    // playing it safe with a timeout outside of $digest land

    return setTimeout(function () {
      return window.location.href = base + path.substring(1);
    }, 100);
  };

  // skipNavigation avoids recursion when we do an eventService.cleanScope() in the HomePageCtrl
  $rootScope.returnToHolodeck = function (skipNavigation, useRootPathInstead) {
    delete $rootScope.event;
    $rootScope.event = null;
    var redirectPath;
    if (!useRootPathInstead) {
      redirectPath = '/holodeck';
    } else {
      redirectPath = '/';
    }
    var holodeckUrl = "".concat(urlService.getTopLevelAppInstanceUrl(redirectPath));
    if (!skipNavigation) {
      $rootScope.navigateHard(holodeckUrl);
    }
  };

  // this renders nav links as .active if they are actually active
  $rootScope.isActiveRoute = function () {
    for (var _len3 = arguments.length, testNavRoutes = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      testNavRoutes[_key3] = arguments[_key3];
    }
    var currentPath = (($route.current || {}).$$route || {}).path;
    if (!currentPath || !testNavRoutes || !testNavRoutes.length) {
      return false;
    }
    return !(0, _lodash.difference)(testNavRoutes, currentPath).length;
  };
  $rootScope.getGeoOptimalEventUrl = function (eventOrEventId, suffixPath) {
    if ((0, _lodash.isString)(eventOrEventId)) {
      eventOrEventId = (0, _lodash.findWhere)(($rootScope.user || {}).events, {
        _id: eventOrEventId
      });
      if (!eventOrEventId) {
        return;
      }
    }
    return eventService.generateGeoOptimalEventUrl(eventOrEventId, suffixPath);
  };
  $rootScope.getTopLevelAppInstanceUrl = urlService.getTopLevelAppInstanceUrl;
  $rootScope.setFlashMessage = function (message) {
    var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'success';
    // backwards compatibility with old angular notifications
    if (level === 'danger') {
      level = 'error';
    }
    return window.BSTG.noty.$notify({
      group: 'flashes',
      text: message,
      type: level
    });
  };
  $rootScope.unsetFlashMessage = function () {
    return delete $rootScope.flashMessage;
  };
  $rootScope.setNavigationWarningMessage = function (message) {
    return $rootScope.navigationWarningMessage = message;
  };
  $rootScope.getPageTitle = function (appName) {
    var event = $rootScope.event;
    if (!event) {
      return appName;
    }
    var eventName = eventService.getName(event);
    if (eventName) {
      return "".concat(eventName, " - ").concat(appName);
    } else {
      return appName;
    }
  };
  $rootScope.getPreviouslyAccessedEventId = function () {
    return previouslyAccessedEventId;
  };
  $rootScope.getPreviouslyAccessedLocationUri = function () {
    return previouslyAccessedLocationUri;
  };

  // FINAL INIT OF ALL SERVICES IN THE RIGHT ORDER

  // figure out what the router is able to do for us (and keep trying if this results in an error)
  var getRouterInfoFn = function getRouterInfoFn() {
    var forceAuthStateRefreshOnSuccess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return routerService.getRouterInfo().then(function (routerInfo) {
      $rootScope.beError = false;
      if (forceAuthStateRefreshOnSuccess) {
        // do a full reload
        return $window.location.reload();
      }
      $rootScope.routerInfo = routerInfo;
    }).catch(function (_ref2) {
      var status = _ref2.status,
        statusText = _ref2.statusText;
      $rootScope.routerInfo = null;
      $rootScope.beError = true;

      // try again in 3 seconds
      $timeout((0, _lodash.partial)(getRouterInfoFn, true), 3000);
      console.warn('[App] Initial load failed', status, statusText);
      return $q.reject('Initial load failed');
    });
  };
  var isValidEventNode = function isValidEventNode(event) {
    var url = window.location.href;
    var node = (0, _url.getNodeName)(url);
    return Boolean(event.nodes[node]);
  };
  var redirectToRootNode = function redirectToRootNode(event) {
    var rootNode = (0, _workspaces.getRootNodeName)(event);
    var rootNodeUrl = (0, _url.getBackstageURL)(rootNode, "/event/".concat(event._id), '', 'https');
    window.location.href = rootNodeUrl;
  };

  // initFinished promise will resolve when everything is ready
  $rootScope.initFinished = getRouterInfoFn().then(function () {
    // refresh the current state on startup
    // once this is done, tag root scope (we do not want to have the login shown before checking the user)
    var consumeAccreditedLinkToken = $q.resolve();
    var linkToken = $location.search()[ACCREDITED_LINK_TOKEN_PARAM];
    if (linkToken) {
      // cleanup token, it has been used
      consumeAccreditedLinkToken = $http.get("/api/v1/session/".concat(eid, "/").concat(linkToken));
    }
    window.BSTG.services.user.init(null, eid);
    return consumeAccreditedLinkToken.then(function () {
      return userService.init(eid);
    }).catch(function (error) {
      if (error.status === 401) {
        $rootScope.setNavigationWarningMessage('You are not authorized to access this event.');
        $rootScope.navigateHard(urlService.getTopLevelAppInstanceUrl('/', "accessed_eid=".concat(eid)));
        return Promise.reject('Unauthorized');
      }
    }).then(function () {
      if (!$rootScope.user) return;
      var user = $rootScope.user;
      window.BSTG.services.user.init(user, eid);
      window.BSTG.services.track.setUser(user, window.BSTG.services.user.isAdmin());
      window.BSTG.services.support.setUser(user);
      window.BSTG.services.crashReporting.setUser(user);
      window.BSTG.services.template.setUser(user);
    });
  }).then(function () {
    if (!$rootScope.user) return;
    var user = userService.getCurrentUser();
    if (!eid) {
      window.BSTG.services.blueprint.init({
        user: user,
        require: BSTG.require
      }).then(function (bp) {
        return blueprintService.init(bp);
      });
      return;
    }

    // initialize signalService only if we are in an event context
    signalService.init(eid);
    return eventService.init(eid, userService.getCurrentUser()).catch(function (error) {
      if (error.status === 403) {
        $rootScope.setNavigationWarningMessage('You are not authorized to access this event.');
        $rootScope.navigateHard(urlService.getTopLevelAppInstanceUrl('/', "accessed_eid=".concat(eid)));
        return Promise.reject('Forbidden');
      }
    }).then(function () {
      var event = eventService.getCurrentEvent();
      var eventStage = (0, _lodash.get)(event, 'lifecycle.stage');
      if (!event || eventStage === 'archived' || eventStage === 'destroyed') {
        $rootScope.navigateHard(urlService.getTopLevelAppInstanceUrl('/', "accessed_eid=".concat(eid)));
        return Promise.reject("Event not available - ".concat(eventStage));
      }
      if ((0, _url.isInfra)() && !isValidEventNode(event)) {
        return redirectToRootNode(event);
      }
      window.BSTG.services.documents.setTimezone(event.timezone);
      return event;
    }).then(function (event) {
      return $q.all([window.BSTG.services.blueprint.init({
        event: event,
        user: user,
        require: BSTG.require
      }), i18nService.init(), window.BSTG.services.metadata.compileMetadata(eid), metadataService.fetchAllMetadata(eid),
      // just a preload
      eventService.compilei18n(eid)]);
    }).then(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 1),
        blueprint = _ref4[0];
      if (userService.isEventSpeaker(eid) || userService.isEventModerator(eid)) {
        return {};
      }
      return [blueprint, window.BSTG.services.market.getInstalledPackages(eid)];
    }).then(function (_ref5) {
      var _ref6 = _slicedToArray(_ref5, 2),
        blueprint = _ref6[0],
        installedPkgs = _ref6[1];
      // This is used to decide what appscripts we should use in theme editor
      // When we merged `theme-editor` package back to backstage we moved these
      // appscripts to `backstage-skeleton`
      window.BSTG.skeletonVersion = installedPkgs['backstage-skeleton'];
      return blueprintService.init(blueprint, eid);
    });
  }).then(function () {
    if (!$rootScope.user) return;
    if (eid) {
      var isInvitedByLink = userService.isInvitedByLink(eventService.getCurrentEvent());
      $rootScope.hideNavs = isInvitedByLink;
      $rootScope.hideChecklist = isInvitedByLink;
    }
    var routeParams = $location.search();
    if (routeParams && routeParams.hideNavs) {
      $rootScope.hideNavs = true;
    }
    if ($rootScope.hideNavs) {
      // this is loaded in `buildMenu` and skipped if navs are hidden
      window.initNotifications();
    }
  }).then(function () {
    console.log('App Init' + (eid ? ' for event ' + eid : ' for global'));
    $route.reload();
  });
}]);